import { Context } from "effect";
/** The signed-in account an account operation acts for. */
export class CurrentPrincipal extends Context.Tag("@pima/authorized-data/CurrentPrincipal")() {
}
/** The PIMA service an internal operation acts as. */
export class CurrentPimaInternal extends Context.Tag("@pima/authorized-data/CurrentPimaInternal")() {
}
/** dearest-api, for the operations PIMA One serves it. */
export class CurrentDearestInternal extends Context.Tag("@pima/authorized-data/CurrentDearestInternal")() {
}
/** Omnitracker, for the deliveries it pushes. */
export class CurrentOmnitracker extends Context.Tag("@pima/authorized-data/CurrentOmnitracker")() {
}
/** dearest-api's internal-access caller, for the account lifecycle PIMA One drives. */
export class CurrentInternalAccess extends Context.Tag("@pima/authorized-data/CurrentInternalAccess")() {
}
export const internalAccessCaller = {
    kind: "internal-access",
};
/** The signed-in Dearest app user, for the operations they run on their own account. */
export class CurrentDearestUser extends Context.Tag("@pima/authorized-data/CurrentDearestUser")() {
}
export const pimaInternal = (service) => ({ kind: "pima-internal", service });
export const dearestUser = (userId) => ({
    kind: "dearest-user",
    userId,
});
//# sourceMappingURL=principal-context.js.map